export default __webpack_public_path__ + "static/image151-43902d4df78a493f747d3b48de5dd69f.jpg";